import { getToken, randomStr, storage } from "@/CommonDP/utils";

export function isDef(v) {
  return v !== undefined && v !== null;
}

export function isPromise(val) {
  return isDef(val) && typeof val.then === "function" && typeof val.catch === "function";
}
export function getValueByKey(obj, key, defaultValue = "") {
  if (obj && Object.hasOwnProperty.call(obj, key)) {
    return obj[key];
  } else {
    return defaultValue;
  }
}
// 日期格式化
export function dateFormatter(time, fmt) {
  const $this = new Date(time);
  const o = {
    "M+": $this.getMonth() + 1,
    "d+": $this.getDate(),
    "h+": $this.getHours(),
    "m+": $this.getMinutes(),
    "s+": $this.getSeconds(),
    "q+": Math.floor(($this.getMonth() + 3) / 3),
    S: $this.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
}

// 请求拦截
export function interceptRequest(config, loadingInstance) {
  const params = config.params || {};
  const flowArray = JSON.parse(storage.get("flowId")) || [];
  if (flowArray.length > 0 && !config.url.includes("flowInstanceId")) {
    Object.assign(params, { flowInstanceId: flowArray[flowArray.length - 1].value, _: randomStr(4) });
  } else {
    Object.assign(params, { _: randomStr(4) });
  }
  if (config.method === "get" && config.data) {
    Object.assign(params, config.data);
  }
  config.params = params;
  // if (flowArray.length > 0) {
  //   debugger;
  // }
  config.headers["Content-Type"] = config.headers["Content-Type"] ? config.headers["Content-Type"] : "application/json";
  config.headers["Authorization"] = config.headers["Authorization"] ? config.headers["Authorization"] : getToken() ? "Bearer " + getToken() : "";
  return config;
}
